import { useEffect, useRef } from "react";
import { gsap } from "gsap";

const Text = ({ text, fontColor, textSize, weight, disappear }) => {
  const textRef = useRef();
  const altTextRef = useRef();
  const letters = text.split("");

  useEffect(() => {
    let ctx = gsap.context(() => {
      const spans = textRef.current.querySelectorAll("span");

      const altSpans = altTextRef.current.querySelectorAll("span");

      if (disappear) {
        
        gsap.to(spans, {
          y: -30,
          duration: 0.06,
          opacity: 0,
          stagger: { each: 0.03, from: "end" },
        });

        gsap.fromTo(altSpans, {
            y: 30,
            opacity: 0,
        },
        {
          y: 0,
          duration: 0.06,
          opacity: 1,
          delay: (spans.length - 1) * 0.03,
          stagger: { each: 0.03, from: "start" },
        });

      } else {

        gsap.fromTo(altSpans, {
            y: 0,
            opacity: 1,
        },
        {
            y: 30,
            opacity: 0,
            duration: 0.06,
            stagger: { each: 0.03, from: "end" },
        });

        gsap.fromTo(spans, {
            y: -30,
            opacity: 0
        },
        {
          y: 0,
          duration: 0.06,
          opacity: 1,
          delay: (spans.length - 1) * 0.03,
          stagger: { each: 0.03, from: "start" },
        });

      }

    }, textRef);

    return () => ctx.revert();
  }, [disappear]);

  return (
    <div
      className="letters"
      style={{ color: fontColor, fontSize: textSize, fontWeight: weight, display: "flex" }}
    >
      <div ref={textRef} style={{overflow: "hidden"}}>
        {letters.map((char, i) => (
            <span key={i} style={{ display: "inline-block", whiteSpace: "pre"}}>
            {char}
            </span>
        ))}
      </div>

      <div ref={altTextRef} style={{position: "absolute", overflow: "hidden"}}>
        {letters.map((char, i) => (
            <span key={i} style={{ display: "inline-block", whiteSpace: "pre", opacity: 0}}>
            {char}
            </span>
        ))}
      </div>

    </div>
  );
};

export default Text;